import React, { createContext, useContext, useState, useMemo, useEffect } from 'react';
import { conversionColorMapping, defaultTheme } from '../constants/colorMapping';
import { useLocation } from 'react-router-dom';
import { log } from '../utils/logger';

const ConversionContext = createContext();

export function ConversionProvider({ children }) {
  const [selectedConversion, setSelectedConversion] = useState('default');
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (!location.pathname.startsWith('/convert/')) {
      setSelectedConversion('default');
    }
  }, [location.pathname]);

  const conversionTitle = useMemo(() => {
    if (selectedConversion === 'default') return null;

    const title = selectedConversion
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, str => str.toUpperCase())
      .split('To');

    if (title.length !== 2) return null;

    return {
      from: title[0].trim(),
      to: title[1].trim()
    };
  }, [selectedConversion]);

  const currentTheme = useMemo(() => {
    log('Computing theme for:', selectedConversion);
    return selectedConversion === 'default' 
      ? defaultTheme 
      : (conversionColorMapping[selectedConversion] || defaultTheme);
  }, [selectedConversion]);

  const value = {
    selectedConversion,
    setSelectedConversion,
    currentTheme,
    isLoading,
    setIsLoading,
    conversionTitle
  };

  return (
    <ConversionContext.Provider value={value}>
      {children}
    </ConversionContext.Provider>
  );
}

export function useConversion() {
  const context = useContext(ConversionContext);
  if (context === undefined) {
    throw new Error('useConversion must be used within a ConversionProvider');
  }
  return context;
}
